// Куда вести клиента по каждой проверке: экран кабинета, где это чинится, и страница
// документации, где написано зачем.
//
// Здесь, а не в базе и не на бэке: текст проверки живёт в локалях фронта, и ссылка должна
// меняться тем же коммитом, что и текст. Бэк отдаёт только код, статус и цифры.
//
// `fix` — маршрут кабинета; `doc` — страница на doc.mison.uz. Проверки без ссылок
// (их чинит поддержка, а не клиент) просто не попадают в список.

const DOCS = 'https://doc.mison.uz/docs'

const CHECK_CATALOG = {
	// Фискализация
	service_enabled: { doc: `${DOCS}/fiscalization/start` },
	pos_tin: { fix: '/pos', doc: `${DOCS}/fiscalization/start` },
	terminal: { fix: '/terminals', doc: `${DOCS}/fiscalization/terminal` },
	terminal_provider: { fix: '/terminals', doc: `${DOCS}/fiscalization/terminal` },
	terminal_serial: { fix: '/terminals', doc: `${DOCS}/fiscalization/terminal` },
	payment_type_fiscal: { fix: '/payment-types', doc: `${DOCS}/fiscalization/payment-types` },
	products_fiscal_code: { fix: '/products', doc: `${DOCS}/fiscalization/mxik` },
	products_tax_category: { fix: '/products', doc: `${DOCS}/fiscalization/mxik` },
	driver: { doc: `${DOCS}/fiscalization/driver` },
	z_report: { doc: `${DOCS}/fiscalization/z-report` },
	cheques_fiscalized: { doc: `${DOCS}/fiscalization/driver` },

	// Агрегаторы: Яндекс, Узум, Wolt, Chakana, Yetkaz
	credentials: { fix: '/external-integrations', doc: `${DOCS}/integrations/start` },
	poses: { fix: '/external-integrations', doc: `${DOCS}/integrations/start` },
	external_group: { fix: '/external-menu', doc: `${DOCS}/integrations/external-menu` },
	categories: { fix: '/external-menu', doc: `${DOCS}/integrations/external-menu` },
	items_sent: { fix: '/external-menu', doc: `${DOCS}/integrations/external-menu` },
	items_blocked: { fix: '/external-menu', doc: `${DOCS}/integrations/external-menu` },
	payment_type: { fix: '/payment-types' },
	order_type: { fix: '/order-types-subs' },
	auto_payment: { fix: '/external-integrations' },
	orders_received: { doc: `${DOCS}/integrations/start` },

	// Внешние курьерские службы
	token: { fix: '/external-couriers', doc: `${DOCS}/delivery/couriers` },
	courier_poses: { fix: '/external-couriers', doc: `${DOCS}/delivery/couriers` },
	pos_coordinates: { fix: '/pos', doc: `${DOCS}/delivery/couriers` },
	pos_phone: { fix: '/pos' },
	pos_address: { fix: '/pos' },

	// Витрина своих каналов
	catalog_categories: { fix: '/menu', doc: `${DOCS}/menu/external` },
	catalog_products: { fix: '/products', doc: `${DOCS}/menu/external` },
	catalog_blocked: { fix: '/products', doc: `${DOCS}/menu/external` },
	catalog_stop_list: { fix: '/products' },
	catalog_stop_list_online: { fix: '/pos', doc: `${DOCS}/menu/stop-list` },
	catalog_prices: { fix: '/products' },

	// Каналы продаж
	channel_active: { fix: '/external-integrations' },
	channel_credentials: { fix: '/external-integrations' },
	channel_poses: { fix: '/external-integrations' },
	channel_order_type: { fix: '/order-types-subs' },
	channel_payment_type: { fix: '/payment-types' },
	channel_orders_received: {},

	// SMS
	sms_provider: { fix: '/external-sms-provider', doc: `${DOCS}/sms/mison` },
	sms_credentials: { fix: '/external-sms-provider', doc: `${DOCS}/sms/mison` },
	sms_balance: { fix: '/subscription' },
	sms_routes: { fix: '/notification-settings' },

	// База точки
	base_menu: { fix: '/menu' },
	base_products: { fix: '/products' },
	base_products_price: { fix: '/products' },
	base_cashiers: { fix: '/employees' },
	base_payment_types: { fix: '/payment-types' },
	base_cashbox: { fix: '/cashbox' },
	base_wms: { fix: '/wms-all' },
	base_suppliers: { fix: '/suppliers' },
	base_preparation_places: { fix: '/preparation-places' },
	base_print_routes: { fix: '/print-routes' },
	base_halls: { fix: '/tables' },

	// Оборудование
	pos_online: { doc: `${DOCS}/pos/connection` },
	printers: { fix: '/devices', doc: `${DOCS}/pos/printers` },
	printers_unassigned: { fix: '/devices', doc: `${DOCS}/pos/printers` },
	devices: { fix: '/devices' },
	attendance: { fix: '/devices' },
	client_version: { fix: '/help' },
	last_sync: { fix: '/synchronizations' },
}

export function checkLinks(code) {
	return CHECK_CATALOG[code] || {}
}

// Иконка статуса одна на все проверки: смысл несёт цвет и текст, а не рисунок.
export const STATUS_ICONS = {
	ok: 'uil-check-circle text-success',
	warning: 'uil-exclamation-triangle text-warning',
	error: 'uil-times-circle text-danger',
	skipped: 'uil-minus-circle text-muted',
}

export default CHECK_CATALOG
